var BlockView = require('views/block/base-block-view');
var ActivityCollectionView = require('views/block/activity/activity-collection-view');

var ActivityView = BlockView.extend({
  regions: {
    'activities': '.activities'
  },
  load: function() {
    var items;
    if(this.model.get('module_key')) {
      if(EF.modules.find(module => module.get('key') === this.model.get('module_key'))) {
        items = EF.modules.find(module => module.get('key') === this.model.get('module_key')).activities;
      }
    }
    if(!items) {
      items = EF.module.activities;
    }
    if(!(items instanceof Chaplin.Collection)) {
      items = new Chaplin.Collection(items);
    }
    this.model.set('all_complete', items.every(function(m) { return m.get('completed'); }));
    items.every(function(m) { return m.get('completed'); });

    var activityCollectionView = new ActivityCollectionView({
      region: 'activities',
      model: this.model,
      collection: items
    });
    this.subview('activities', activityCollectionView);
  },
  play: function() {
    this.readyToGo();
  }
});

module.exports = ActivityView;
